export default {
  title: 'Reason for visit',
  add: 'Add reason for visit',
  change: 'Change reason for visit',
  filter: 'Reasons for visit'
};
